import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  EbatV2NavigationDefaultProps,
  EbatV2NavigationPropTypes,
} from '@/ebat/router/EbatV2Navigation/EbatV2Navigation.proprtypes';
import v2Routes from '@/eBatV2Routes.json';

const isSupportedV2Route = (pathname) =>
  v2Routes.reduce(
    (accu, route) => (pathname.startsWith(route) ? true : accu),
    false,
  );

const EbatV2Navigation = ({ children }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  useEffect(() => {
    const unlisten = history.listen(({ pathname: nextPathName }) => {
      if (isSupportedV2Route(nextPathName)) {
        window.location.reload();
      }
    });
    return () => {
      unlisten();
    };
  }, [history]);

  if (isSupportedV2Route(pathname)) {
    return null;
  }

  return children;
};

EbatV2Navigation.defaultProps = {
  ...EbatV2NavigationDefaultProps,
};

EbatV2Navigation.propTypes = {
  ...EbatV2NavigationPropTypes,
};

export default EbatV2Navigation;
